import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../shared/api.service';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { EditOffreComponent } from './edit-offre/edit-offre.component';
import { LocalDataSource } from 'ng2-smart-table';
import { Router } from '@angular/router';
import { plainToClass } from 'class-transformer';
import swal from 'sweetalert2';
import { Formation } from '../../shared/data/formation';
import { LicenceKey } from '../../shared/data/licencekey';
import { User } from '../../shared/data/user';
import { Offre } from '../../shared/data/offre';

@Component({
  selector: 'ngx-offre',
  templateUrl: './offre.component.html',
  styleUrls: ['./offre.component.scss']
})
export class OffreComponent implements OnInit {

  categories:any =[];
  
  source: LocalDataSource =  new LocalDataSource();
  settings = {
 
     hideSubHeader: false,
     mode: 'external',
     actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
     },
     add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
     edit: {
       editButtonContent: '<i class="nb-edit"></i>',
       saveButtonContent: '<i class="nb-checkmark"></i>',
       cancelButtonContent: '<i class="nb-close"></i>',
       confirmSave:false
     },
     delete: {
       deleteButtonContent: '<i class="nb-trash"></i>',
       confirmDelete: true,
     },
   columns: {
    id: {
       title: 'ID',
       type: 'number',
       filter: false,
    },
    is_publish: {
      title: 'Publier',
      type: 'string',
    },
    titre: {
      title: 'Titre',
      type: 'string',
    },
    nbr_data_base: {
      title: 'Nombre dossier',
      type: 'string',
    },
    nbr_jour: {
      title: 'Nombre de jour',
      type: 'string',
    },
    useroffer: {
      title: 'Type d\'offre',
      type: 'string',
      valuePrepareFunction: (useroffer) => { return (useroffer)?'Avec compte':'Sans compte'; },
    },
     /* labelCycle: {
      title: 'Cycle',
      type: 'string',
    }, */
    /* label_categorie: {
      title: 'Categorie',
      type: 'string',
    }, */
    /* labelAdmission: {
      title: 'Admission',
      type: 'string',
    }, */
   /*  is_publish: {
      title: '',
      type: 'custom',
      renderComponent: PublishRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
      filter: false,
    }, */
  
   },
   pager : {
                 perPage :10
   },
  
  };

 constructor(private router:Router,private dialogService: NbDialogService,private apiService:ApiService,private sendeurService:EventSendeurService,private toastr:NbToastrService) { }
 
 
  ngOnInit() {

    this.getOffres();

    /* this.sendeurService.formationEvent.subscribe(data =>{
      this.getOffres();
    }); */

  }

 

  getOffres(){

    this.apiService.getAllOffreProvider().subscribe(data =>{
     

      this.source.load( plainToClass( Offre, data) );
      /* const tmps = data as any[];   
      this.categories = tmps.map(tmp => {
        return {
        
          nom: tmp.nom,   
          id:tmp.id,
          description:tmp.description
        };
      
      }); */

    })

  }

  
  

  onDelete(event){
    // this.dialogService.open(DeleteCategoryComponent,{ context:{id:$event.data.id}});

    // this.dialogService.open(DeletePageComponent,{context:{id:$event.data.id}});
    const offre = plainToClass( Offre,  event.data as object);
    
    swal({
      title: 'Suppression offre',
      text: 'Voulez - vous vraiment supprimer ' + offre.titre + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteOffreProvider(offre.id).subscribe(data =>{

          // console.log(data);
          this.source.remove(event.data);
          this.toastr.success("Suppréssion réussie", offre.titre);

        },(err) =>{

          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }

          if(err.error.code ===500){

            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");

          }

        })

      },
    }).then((result) => {

      if (result.value) {


        /* this.toastr.success("Suppréssion réussie", formation.titre); */

      }

      // this.dialogIsNotShow = false;

    });


  }

  
  select($event){
    this.dialogService.open(EditOffreComponent,{context:{id:$event.data.id}});
  }

  onCreate(event){
    this.createFormation();
  }

  createFormation(){
    this.dialogService.open(EditOffreComponent,{context:{id:0}});
  }

  

}
